'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import BreakdownScoreContainer from '../BreakdownScoreContainer';
import ResultSection from '../result/ResultSection';
import RadialProgressBar from '../RadialProgressBar';
import OverallData from '../../data/components/OverallData';
import OverallResultSection from '../result/OverallResultSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MON109_CMS_DTT_LINK } from '../../constants/TrialConstants';
import usageTracker from '../../lib/usageTracker';
import { parseUtmParams } from '../../util/Urls';

var NoCreditCard = function NoCreditCard() {
  return /*#__PURE__*/_jsx("span", {
    className: "no-credit-card",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "results.sidePanel.overallGrade.cta.noCreditCard"
    })
  });
};

var CTABottom = function CTABottom(_ref) {
  var onClick = _ref.onClick;
  var parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsxs("div", {
    className: "cta-section",
    children: [/*#__PURE__*/_jsx("div", {
      className: "cta-title",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "cta-microcopy",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.microcopy"
      })
    }), /*#__PURE__*/_jsx("a", {
      className: "button white",
      target: "_blank",
      rel: "noopener noreferrer",
      href: MON109_CMS_DTT_LINK + "&" + parsedUtmParams,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trialBanner.ctaButton"
      })
    }), /*#__PURE__*/_jsx(NoCreditCard, {})]
  });
};

var handleClick = function handleClick(_ref2) {
  var websiteUrl = _ref2.websiteUrl;
  usageTracker.log('trialBannerClick', {
    type: 'dtt-cta-click',
    websiteUrl: websiteUrl,
    source: 'trial-cta-sidepanel'
  });
};

export default (function (_ref3) {
  var websiteGrade = _ref3.websiteGrade;
  var url = websiteGrade.get('domain');
  var grade = websiteGrade.get('overallGrade');
  var overallData = new OverallData().init(grade);
  var gradeType = overallData.gradeType;
  return /*#__PURE__*/_jsx("div", {
    className: "sidepanel-overall-grade",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: gradeType,
        children: [/*#__PURE__*/_jsx(RadialProgressBar, {
          score: grade,
          children: grade
        }), /*#__PURE__*/_jsx("div", {
          className: "website-url",
          children: url
        }), /*#__PURE__*/_jsx("div", {
          className: "side-panel-result-section",
          children: /*#__PURE__*/_jsx(OverallResultSection, {
            websiteGrade: websiteGrade
          })
        }), /*#__PURE__*/_jsx(BreakdownScoreContainer, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(CTABottom, {
          onClick: function onClick() {
            return handleClick({
              websiteUrl: url
            });
          }
        })]
      })
    })
  });
});